import { LoggedOutHomeImage } from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/__internal__/LoggedOutHomeImage/LoggedOutHomeImage";
import { Core } from "@faire/design-tokens";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { MIN_WIDTH_BREAKPOINTS } from "@faire/web/common/media";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

import {
  MOBILE_BANNER_HEIGHT,
  TABLET_BANNER_HEIGHT,
  XLARGE_BANNER_HEIGHT,
  DESKTOP_BANNER_HEIGHT,
} from "../styles.css";

export const WeMakeItSimpleRightImage: React.FC = () => {
  const { isTabletAndAbove } = useViewport();
  return (
    <>
      <LoggedOutHomeImage
        lazyLoad
        responsiveImage={{
          mobileAndAbove: IImage.build({
            url: "https://cdn.faire.com/fastly/48793107444445287628bcd1d7e74cb936b8e8e3086cc559f20fba2a9971b301.jpeg",
          }),
          tabletAndAbove: IImage.build({
            url: "https://cdn.faire.com/fastly/5f12fe62a6f9073e2fcc86a838d2328c90baec9d283ff4ef8adff84f7ecf44da.jpeg",
          }),
          desktopAndAbove: IImage.build({
            url: "https://cdn.faire.com/fastly/591072d0058535e7f6ae2406958750224d68f9950cdc5382923711050ba9d6f8.jpeg",
          }),
          xLargeAndAbove: IImage.build({
            url: "https://cdn.faire.com/fastly/6dfffc60b732e950f90c0fa3a24928b518f66ae1190643f01e63054b29f15212.jpeg",
          }),
        }}
        optimizeImageOptions={{
          mobileAndAbove: {
            width: 375,
            height: MOBILE_BANNER_HEIGHT,
          },
          tabletAndAbove: {
            width: MIN_WIDTH_BREAKPOINTS.TABLET / 2,
            height: TABLET_BANNER_HEIGHT,
          },
          desktopAndAbove: {
            width: MIN_WIDTH_BREAKPOINTS.DESKTOP / 2,
            height: DESKTOP_BANNER_HEIGHT,
          },
          xLargeAndAbove: {
            width: MIN_WIDTH_BREAKPOINTS.XLARGE / 2,
            height: XLARGE_BANNER_HEIGHT,
          },
        }}
        imageStyles={
          isTabletAndAbove
            ? {
                display: "inline",
                minHeight: "100%",
              }
            : {}
        }
      />
      <div
        className="absolute bottom-8 flex flex-col"
        style={{ padding: `${getSpacing(0, "4x")}` }}
      >
        <Typography variant="paragraphSansMedium" color={Core.text.inverse}>
          <StrictLocalMsg
            id="9W46UD"
            defaultMessage="Annika Huston, Owner of Dotter"
            description={{
              text: "Logged out home page we make it simple banner brand info",
              img: "https://cdn.faire.com/fastly/4349460ba1651c3e1fca9882872e43375e1cd14561e84974ed37684b951d8fd5.png",
            }}
          />
        </Typography>
        <Typography color={Core.text.inverse}>
          <StrictLocalMsg
            id="hTrpYV"
            defaultMessage="Los Angeles, California"
            description={{
              text: "Logged out home page we make it simple banner brand info",
              img: "https://cdn.faire.com/fastly/6f2f577b59b1290ddafc39c29d6edad276d0b4d00d900281891384bbcea68be8.png",
            }}
          />
        </Typography>
      </div>
    </>
  );
};
